import { type HTMLAttributes, type ReactNode } from 'react'

type InputGroupProps = {
  className?: string
  label?: ReactNode & HTMLAttributes<HTMLLabelElement>
  input: ReactNode & HTMLAttributes<HTMLInputElement>
} & HTMLAttributes<HTMLDivElement>

const InputGroup = ({ className = '', label, input, ...props }: InputGroupProps) => {
  return (
    <div className={`input-group ${className}`} {...props}>
      {label}
      {input}
    </div>
  )
}

export default InputGroup
